import Loader from '@anm/components/Loader';
import Image from '@anm/components/image/Image';
import { FC } from 'react';

import { ChannelRow, LoaderContainer } from './Wrapper';

type ChanelItemProps = {
  channel: string;
  onDeleteChannel(channel: string): void;
};

type ChannelsListProps = {
  isPending: boolean;
  channels?: string[];
  onDeleteChannel(channel: string): void;
};

const ChannelItem: FC<ChanelItemProps> = ({ channel, onDeleteChannel }) => (
  <ChannelRow>
    {channel}
    <Image
      src="images/icons/trash.svg"
      alt="delete youtube chanel"
      onClick={() => onDeleteChannel(channel)}
    />
  </ChannelRow>
);

const ChannelsList: FC<ChannelsListProps> = ({
  channels,
  isPending,
  onDeleteChannel
}) => {
  if (isPending) {
    return (
      <LoaderContainer>
        <Loader size="medium" color="blue" />
      </LoaderContainer>
    );
  }

  return (
    <>
      {channels?.map(channel => (
        <ChannelItem key={channel} {...{ channel, onDeleteChannel }} />
      ))}
    </>
  );
};

export default ChannelsList;
